module.exports = [
    {
        "branchName": "Demo Office",
        "idBranch": "32517238",
        "idAgent": "66604327df",
        "idUser": 1789847,
        "agentDisplay1": "",
        "agentDisplay2": "",
        "agentDisplay3": "",
        "agentDisplay4": "",
        "agentDisplay5": "",
        "agentDisplay6": "",
        "agentDisplay7": "",
        "agentDisplay8": "",
        "agentEmail": "promotest@email.com",
        "agentNameFirst": "Promo Test",
        "agentNameLast": "(No Past Orders)",
        "agentNameMiddle": "",
        "agentPhone1": "0000000000",
        "agentPhone2": "",
        "agentActive": 1,
        "agentLinkId": "",
        "headshot": "",
        "userActive": true,
        "loginLevel": 4
    },
    {
        "branchName": "",
        "idBranch": "9432cf10",
        "idAgent": "41d78df1",
        "idUser": 2142412,
        "agentDisplay1": "",
        "agentDisplay2": "",
        "agentDisplay3": "",
        "agentDisplay4": "",
        "agentDisplay5": "",
        "agentDisplay6": "",
        "agentDisplay7": "",
        "agentDisplay8": "",
        "agentEmail": "",
        "agentNameFirst": "",
        "agentNameLast": "",
        "agentNameMiddle": "",
        "agentPhone1": "",
        "agentPhone2": "",
        "agentActive": 1,
        "agentLinkId": "pstest3",
        "headshot": "https:\/\/assets.awsdev.xpressdocs.com\/dserv\/p\/8\/32112389.png",
        "userActive": true,
        "loginLevel": 5
    },
    {
        "branchName": "Demo Office",
        "idBranch": "32517238",
        "idAgent": "590a03edb4",
        "idUser": 1399706,
        "agentDisplay1": "John Agent",
        "agentDisplay2": "Licensed RE Salesperon",
        "agentDisplay3": "apm2@xpressdocs.com",
        "agentDisplay4": "m. 866.977.3627",
        "agentDisplay5": "d. 123.456.7899",
        "agentDisplay6": "f. 852.369.5632",
        "agentDisplay7": "johnagent.com",
        "agentDisplay8": "facebook.com\/jagent",
        "agentEmail": "tfrazier@xpressdocs.com",
        "agentNameFirst": "John",
        "agentNameLast": "Agent",
        "agentNameMiddle": "",
        "agentPhone1": "8175479711",
        "agentPhone2": "",
        "agentActive": 1,
        "agentLinkId": "samplexd",
        "headshot": "https:\/\/assets.awsdev.xpressdocs.com\/dserv\/p\/8\/26410437.jpg",
        "userActive": true,
        "loginLevel": 5
    },
    {
        "branchName": "IFB Template Test Office",
        "idBranch": "53cbf84c",
        "idAgent": "f68251e4fc",
        "idUser": 1842916,
        "agentDisplay1": "Bess T. Agent",
        "agentDisplay2": "Insurance Broker",
        "agentDisplay3": "bess.t.agent@ifb.demo",
        "agentDisplay4": "555-555-5555",
        "agentDisplay5": "555-555-6666",
        "agentDisplay6": "",
        "agentDisplay7": "www.ifb.demo",
        "agentDisplay8": "@facebook.ifb.besstagent",
        "agentEmail": "bess.t.agent@ifb.demo",
        "agentNameFirst": "Bess T.",
        "agentNameLast": "Agent",
        "agentNameMiddle": "",
        "agentPhone1": "555-555-5555",
        "agentPhone2": "555-555-6666",
        "agentActive": 1,
        "agentLinkId": "bess.t.agent@ifb.demo",
        "headshot": "",
        "userActive": true,
        "loginLevel": 5
    },
    {
        "branchName": "UI-UX",
        "idBranch": "f9e8d00d",
        "idAgent": "f5fd77a16f",
        "idUser": 1804253,
        "agentDisplay1": "Firstname Lastname",
        "agentDisplay2": "Directory of Agency",
        "agentDisplay3": "uiuxagent@xpressdocs.com",
        "agentDisplay4": "8173005000",
        "agentDisplay5": "",
        "agentDisplay6": "",
        "agentDisplay7": "https:\/\/www.xpressdocs.com",
        "agentDisplay8": "",
        "agentEmail": "uiuxagent@xpressdocs.com",
        "agentNameFirst": "uiux",
        "agentNameLast": "agent",
        "agentNameMiddle": "",
        "agentPhone1": "8173005000",
        "agentPhone2": "",
        "agentActive": 1,
        "agentLinkId": "",
        "headshot": "",
        "userActive": true,
        "loginLevel": 5
    },
    {
        "branchName": "Demo Office",
        "idBranch": "32517238",
        "idAgent": "040d37c8e5",
        "idUser": 1542074,
        "agentDisplay1": "ACME Agent",
        "agentDisplay2": "Sales Associate",
        "agentDisplay3": "tes\u00f1@xpressdocs.com",
        "agentDisplay4": "123.456.7654",
        "agentDisplay5": "555.555.0123",
        "agentDisplay6": "123-456-7890",
        "agentDisplay7": "www.xdocs.com",
        "agentDisplay8": "@socialmedia",
        "agentEmail": "tesl@xpressdocs.com",
        "agentNameFirst": "ACME",
        "agentNameLast": "Agent",
        "agentNameMiddle": "",
        "agentPhone1": "123.456.7892",
        "agentPhone2": "(817)555-5555",
        "agentActive": 1,
        "agentLinkId": "aagent@demo.com",
        "headshot": "https:\/\/assets.awsdev.xpressdocs.com\/dserv\/p\/8\/32112305.jpg",
        "userActive": true,
        "loginLevel": 5
    },
    {
        "branchName": "Test Office No Shipping",
        "idBranch": "f6ee898223",
        "idAgent": "bc8507861c",
        "idUser": 1434039,
        "agentDisplay1": "",
        "agentDisplay2": "",
        "agentDisplay3": "",
        "agentDisplay4": "",
        "agentDisplay5": "",
        "agentDisplay6": "",
        "agentDisplay7": "",
        "agentDisplay8": "",
        "agentEmail": "testnoshipping@test.com",
        "agentNameFirst": "Test",
        "agentNameLast": "Agent",
        "agentNameMiddle": "",
        "agentPhone1": "1234567890",
        "agentPhone2": "",
        "agentActive": 1,
        "agentLinkId": "testNoShipping",
        "headshot": "",
        "userActive": true,
        "loginLevel": 5
    },
    {
        "branchName": "Demo Office",
        "idBranch": "32517238",
        "idAgent": "bcd107e7e2",
        "idUser": 1688588,
        "agentDisplay1": "Jonathan Agentname",
        "agentDisplay2": "Title 1",
        "agentDisplay3": "",
        "agentDisplay4": "P: (555) 555-5555",
        "agentDisplay5": "",
        "agentDisplay6": "",
        "agentDisplay7": "jonathan@myreallynewemail.com",
        "agentDisplay8": "www.mynewwebsite.com",
        "agentEmail": "jonathan@myreallynewemail.com",
        "agentNameFirst": "Jonathan",
        "agentNameLast": "Agentname",
        "agentNameMiddle": "",
        "agentPhone1": "(555) 555-5555",
        "agentPhone2": "",
        "agentActive": 1,
        "agentLinkId": "jonathan@myreallynewemail.com",
        "headshot": "",
        "userActive": true,
        "loginLevel": 5
    },
    {
        "branchName": "Demo Office",
        "idBranch": "32517238",
        "idAgent": "bb6ebf8f96",
        "idUser": 1875380,
        "agentDisplay1": "",
        "agentDisplay2": "",
        "agentDisplay3": "",
        "agentDisplay4": "",
        "agentDisplay5": "",
        "agentDisplay6": "",
        "agentDisplay7": "",
        "agentDisplay8": "",
        "agentEmail": "malperin@xpressdocs.com",
        "agentNameFirst": "Mark",
        "agentNameLast": "Alperin",
        "agentNameMiddle": "",
        "agentPhone1": "5622535106",
        "agentPhone2": "",
        "agentActive": 1,
        "agentLinkId": "",
        "headshot": "",
        "userActive": true,
        "loginLevel": 5
    },
    {
        "branchName": "Demo Office",
        "idBranch": "32517238",
        "idAgent": "450ceef41d",
        "idUser": 1875383,
        "agentDisplay1": "",
        "agentDisplay2": "",
        "agentDisplay3": "",
        "agentDisplay4": "",
        "agentDisplay5": "",
        "agentDisplay6": "",
        "agentDisplay7": "",
        "agentDisplay8": "",
        "agentEmail": "abaxter@xpressdocs.com",
        "agentNameFirst": "Austin",
        "agentNameLast": "Baxter",
        "agentNameMiddle": "",
        "agentPhone1": "817-734-3076",
        "agentPhone2": "",
        "agentActive": 1,
        "agentLinkId": "",
        "headshot": "",
        "userActive": true,
        "loginLevel": 5
    },
    {
        "branchName": "Demo Office",
        "idBranch": "32517238",
        "idAgent": "16f4df0e07",
        "idUser": 1440874,
        "agentDisplay1": "Jeremy Beck",
        "agentDisplay2": "Account Executive",
        "agentDisplay3": "jbeck@xpressdocs.com",
        "agentDisplay4": "256.478.6984",
        "agentDisplay5": "",
        "agentDisplay6": "",
        "agentDisplay7": "xpressdocs.com\/enterprise",
        "agentDisplay8": "",
        "agentEmail": "jbeck@xpressdocs.com",
        "agentNameFirst": "Jeremy",
        "agentNameLast": "Beck",
        "agentNameMiddle": "",
        "agentPhone1": "256.478.6984",
        "agentPhone2": "",
        "agentActive": 1,
        "agentLinkId": "",
        "headshot": "",
        "userActive": true,
        "loginLevel": 5
    }
];
